/** App chrome: dark left rail (and related shells). */
export const NAV_RAIL_BG = '#063464'

/** Primary accent: selections, links, primary buttons, sidebar active row. */
export const ACCENT_BLUE = '#0a57a8'

/** Hover / pressed on surfaces already filled with ACCENT_BLUE. */
export const ACCENT_BLUE_HOVER = '#1a7ad4'
